import React, { useState } from "react";
import { borderRadius } from "react-select/src/theme";

interface Props {
  icon: string;
  label: string;
}

const ActionCard: React.FC<Props> = ({ icon: Icon, label }) => {
  const [isHovered, setIsHovered] = useState(false);

  const styles = {
    card: {
      display: "flex",
      flexDirection: "column" as const,
      alignItems: "center",
      // padding: "0.75rem", // p-3
      // width: "7rem", // w-28
      textAlign: "center" as const,
      // backgroundColor: "blue",
    },
    cardHover: {
      transform: "scale(1.08)", // Scale up slightly
      boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)", // Lifted shadow
      backgroundColor: "#f9fafb", // Very light background tint
    },
    iconContainer: {
      // backgroundColor: "#FEF3C7", // bg-yellow-100
      margin: "0 0.50rem", // p-3
      // borderRadius: "50%", // rounded-full
      marginBottom: "0.4rem", // mb-2
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      borderRadius: "16px",
    },
    icon: {
      color: "#B45309", // text-yellow-600
      width: "1.5rem", // w-6
      height: "1.5rem", // h-6
    },
    label: {
      fontSize: "0.875rem", // text-sm
      fontWeight: 500, // font-medium
      paddingTop: "3px",
      cursor: "pointer",
      color: "#000",
    },
  };

  const dynamicLogoStyle = isHovered
    ? { ...styles.iconContainer, ...styles.cardHover }
    : styles.iconContainer;

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={styles.card}
    >
      <div style={dynamicLogoStyle}>
        <img src={Icon} alt={`${Icon}`} />
      </div>
      <span style={styles.label}>{label}</span>
    </div>
  );
};

export default ActionCard;
